document.addEventListener("DOMContentLoaded", () => {
    const searchContainer = document.querySelector('.search');
    const searchInput = document.getElementById('searchInput');
    const searchButton = searchContainer.querySelector('button');

    if (searchInput && searchButton) {
        searchInput.addEventListener('keydown', handleSearch);

        searchButton.addEventListener('click', () => {
            searchContainer.classList.toggle('search-open');

            if (searchContainer.classList.contains('search-open')) {
                searchInput.focus();
            }
        });
    }
});

function handleSearch(event) {
    if (event.key === "Enter") {
        event.preventDefault();
        const query = event.target.value.trim();
        if (query) {
            window.location.href = `/soegning?query=${encodeURIComponent(query)}`;
        }
    }
}